"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomError = void 0;
exports.MissingTargetFileError = MissingTargetFileError;
exports.NoSupportedManifestsFoundError = NoSupportedManifestsFoundError;
class CustomError extends Error {
    constructor(message) {
        super(message);
        Error.captureStackTrace(this, this.constructor);
        this.name = this.constructor.name;
        this.code = undefined;
        this.strCode = undefined;
        this.innerError = undefined;
        this.userMessage = undefined;
    }
}
exports.CustomError = CustomError;
function MissingTargetFileError(path) {
    const errorMsg = `Not a recognised option did you mean --file=${path}? ` +
        'Check other options by running snyk --help';
    const error = new CustomError(errorMsg);
    error.code = 422;
    error.userMessage = errorMsg;
    return error;
}
function NoSupportedManifestsFoundError(atLocations) {
    const locationsStr = atLocations.join(', ');
    const errorMsg = 'Could not detect supported target files in ' +
        locationsStr +
        '.\nPlease see our documentation for supported languages and ' +
        'target files: https://snyk.co/udVgQ' +
        ' and make sure you are in the right directory.';
    const error = new CustomError(errorMsg);
    error.code = 422;
    error.userMessage = errorMsg;
    return error;
}
//# sourceMappingURL=errors.js.map